import { type SxProps, type Theme } from '@mui/material'

export const cardChrome = {
  p: '16px',
  borderRadius: '12px',
  border: '1px solid var(--grey-200)',
  boxShadow: 'var(--shadow-xs)',
  backgroundColor: 'var(--white)'
} satisfies SxProps<Theme>
